export default {
  "head.index": "الرئيسية",
};
